import type { PlatformPixelConfig } from '../types';
import { withOptimizationPixels } from '../../FormViewerPage/services/formViewerService/pixelOptimization';

export function buildThankYouPixelConfigs(form: any, globalTrackingSettings: any): PlatformPixelConfig[] {
  if (!form) return [];
  const trackingSettings = form?.trackingSettings?.thankYouPage;
  const formPageTracking = form?.trackingSettings?.formPage;
  const allConfigs: PlatformPixelConfig[] = [];

  let metaIds: string[] = [];
  // Thanks page form fisik = Lead (order baru Pending, closing nanti via CAPI sweep).
  let metaEvent = 'Lead';
  if (trackingSettings?.meta?.pixelIds?.length) {
    metaIds = trackingSettings.meta.pixelIds.filter((id: string) => id?.trim());
    // WYSIWYG: thanks page belum tentu Purchase (baru Lead) — fire sesuai dropdown.
    metaEvent = trackingSettings.meta.eventName || 'Lead';
  } else if (formPageTracking?.meta?.pixelIds?.length) {
    metaIds = formPageTracking.meta.pixelIds.filter((id: string) => id?.trim());
  }
  // Pixel optimasi iklan brand form ini ikut menerima Lead (browser + CAPI/stash).
  // NOTE: builder ini dipakai submitCapi + ThankYou browser + useGlobalCapi.
  metaIds = withOptimizationPixels(metaIds, globalTrackingSettings?.meta?.pixels, form?.brandId);
  if (metaIds.length) allConfigs.push({ platform: 'meta', pixelIds: metaIds, eventName: metaEvent });

  let googleIds: string[] = [];
  let googleEvent = 'purchase';
  if (trackingSettings?.google?.pixelIds?.length) {
    googleIds = trackingSettings.google.pixelIds.filter((id: string) => id?.trim());
    googleEvent = trackingSettings.google.eventName || 'purchase';
  } else if (formPageTracking?.google?.pixelIds?.length) {
    googleIds = formPageTracking.google.pixelIds.filter((id: string) => id?.trim());
  }
  // Pixel optimasi iklan (Google Ads) brand form ini ikut menerima Lead (browser + CAPI/stash).
  googleIds = withOptimizationPixels(googleIds, globalTrackingSettings?.google?.pixels, form?.brandId);
  if (googleIds.length) allConfigs.push({ platform: 'google', pixelIds: googleIds, eventName: googleEvent });

  let tiktokIds: string[] = [];
  let tiktokEvent = 'CompletePayment';
  if (trackingSettings?.tiktok?.pixelIds?.length) {
    tiktokIds = trackingSettings.tiktok.pixelIds.filter((id: string) => id?.trim());
    tiktokEvent = trackingSettings.tiktok.eventName || 'CompletePayment';
  } else if (formPageTracking?.tiktok?.pixelIds?.length) {
    tiktokIds = formPageTracking.tiktok.pixelIds.filter((id: string) => id?.trim());
  }
  // Pixel optimasi iklan brand form ini ikut menerima Lead TikTok (browser + CAPI/stash).
  tiktokIds = withOptimizationPixels(tiktokIds, globalTrackingSettings?.tiktok?.pixels, form?.brandId);
  if (tiktokIds.length) allConfigs.push({ platform: 'tiktok', pixelIds: tiktokIds, eventName: tiktokEvent });

  let snackIds: string[] = [];
  let snackEvent = 'PURCHASE';
  if (trackingSettings?.snack?.pixelIds?.length) {
    snackIds = trackingSettings.snack.pixelIds.filter((id: string) => id?.trim());
    snackEvent = trackingSettings.snack.eventName || 'PURCHASE';
  } else if (formPageTracking?.snack?.pixelIds?.length) {
    snackIds = formPageTracking.snack.pixelIds.filter((id: string) => id?.trim());
  }
  // Pixel optimasi iklan brand form ini ikut menerima Lead Snack.
  snackIds = withOptimizationPixels(snackIds, globalTrackingSettings?.snack?.pixels, form?.brandId);
  if (snackIds.length) allConfigs.push({ platform: 'snack', pixelIds: snackIds, eventName: snackEvent });

  let openaiIds = trackingSettings?.openai?.pixelIds?.filter((id: string) => id?.trim()) || [];
  const openaiEvent = trackingSettings?.openai?.eventName || 'Lead';
  if (!openaiIds.length) openaiIds = formPageTracking?.openai?.pixelIds?.filter((id: string) => id?.trim()) || [];
  openaiIds = withOptimizationPixels(openaiIds, globalTrackingSettings?.openai?.pixels, form?.brandId);
  if (openaiIds.length) allConfigs.push({ platform: 'openai', pixelIds: openaiIds, eventName: openaiEvent });

  return allConfigs;
}
